import React, { Component } from 'react'
import ReactSpeedometer from 'react-d3-speedometer'

import Box, { CardActions } from '@material-ui/core'
import Card from '@material-ui/Core/Card'
import CardHeader from '@material-ui/Core/CardHeader'
import CardContent from '@material-ui/Core/CardContent'
import Button from '@material-ui/Core/Button'
import Container from '@material-ui/Core/Container'
import Grid from '@material-ui/Core/Grid'

import Speedometer from './results/Speedometer';
import TextSection from './results/TextSection';
import ButtonGroup from './results/ButtonGroup';
import Header from './results/Header';
import HeaderButtons from '../components/results/headerbuttons';
import Callout from './results/Callout';
import Paragraph from './results/paragraph';
import RiskList from './results/risklist';
import RiskBar from './results/riskbar';
import TextDivider from './results/divider';
import Section from './results/section'

import { withStyles } from '@material-ui/core/styles';
import QuestionList from './results/questionlist'

import './result.css'

const useStyles = {
    root: {

    }
}

class QuizResults extends Component {
    constructor(props){
        super(props)
        this.state = {
            expandAccordions: false
        }
    }

    setExpandAccordions(val){
        this.setState({
            expandAccordions: val
        })
    }

    render() {
        const { classes } = this.props
        if (this.props.results[0]){
            var x=0;
            var resultItems = [];
            var component;
            let headerButtons;
            if(this.props.results.length > 6){
                headerButtons = <HeaderButtons email="" downloadPopup={this.props.downloadPopup} expandAccordions={this.setExpandAccordions.bind(this)} name={this.props.name} clientLogo={this.props.clientLogo}/>
            }
            while(x<this.props.results.length){
                //resultItem = ;
                component=this.props.results[x];
                if(component.ComponentVisible=="1"){
                    switch(component.ComponentClass) {
                    case "TEXTAREA":
                        if(component.ComponentFamily == "RISKFACTORS"){
                            resultItems.push(<RiskList content={component.ComponentContent}></RiskList>)
                        }
                        if(component.ComponentType == "HEADER"){
                            resultItems.push(<Header gradeLabel={component.ComponentContent.GradeLabel} content={component.ComponentContent.Title} type={""}/>)
                        }
                        if(component.ComponentType == "SUBHEADER"){

                        }
                        if(component.ComponentType == "TEXT"){
                            resultItems.push(<TextSection type={component.ComponentContent.ContentType} text={component.ComponentContent.Content} />)
                        }
                        if(component.ComponentType == "CALLOUT"){
                            resultItems.push(<Callout content={component.ComponentContent.CallOuts}></Callout>)
                        }
                        if(component.ComponentType == "PARAGRAPH"){
                            resultItems.push(<Paragraph content={component.ComponentContent} expand={this.state.expandAccordions}></Paragraph>)
                        }
                        break;
                    case "CHART":
                        if (component.ComponentFamily == "SPEEDOMETER"){
                            if (component.ComponentType == "SEGMENTED"){
                            resultItems.push(<Speedometer content={component.ComponentContent} score={component.ComponentContent.PrimaryValue} type="SEGMENT"/>)
                            }
                            if (component.ComponentType == "GRADIENT"){
                                resultItems.push(<Speedometer content={component.ComponentContent} score={component.ComponentContent.PrimaryValue} type="GRADIENT"/>)
                            }
                        }
                        if (component.ComponentFamily == "BAR"){
                                resultItems.push(<RiskBar content={component.ComponentContent} />)
                        }
                        

                        break;
                    case "VISUAL":
                        if (component.ComponentFamily == "DIVIDER"){
                            resultItems.push(<TextDivider content={component.ComponentContent} />)
                        }
                        if (component.ComponentFamily == "SECTION"){
                            resultItems.push(<Section content={component.ComponentContent} />)
                        }
                        break;
                    case "RISKFACTOR":
                        if (component.ComponentType == "LIST"){
                            
                        }
                    case "CONTROLS":
                        if (component.ComponentType == "BUTTON GROUP"){
                            resultItems.push(<ButtonGroup buttons={component.ComponentContent.Buttons } showDivider={x==this.props.results.length-1} groupguid={this.props.groupguid} authtoken={this.props.authtoken}/>)
                        }
                        break;
                    case "CARD":
                        if(component.ComponentType == "PARAGRAPH"){
                            //resultItems.push(<ContentCard type="paragraph" content={component.ComponentContent}/>)
                        }
                        break;
                    case "DATA":
                        if (component.ComponentType == "ACCORDION"){
                            resultItems.push(<QuestionList content={component.ComponentContent} expand={this.state.expandAccordions}></QuestionList>)
                        }
                        break;
                }
                }
                
                //console.log(resultItems)
                //resultItems.push(resultItem);
                x++;
            }
            return (
                <Grid>
                    <Card className={classes.card} height="4" raised="true" id="results" style={{paddingLeft:'3vw', paddingRight:'3vw'}}>
                        <CardHeader>
                            
                        </CardHeader>
                        {headerButtons}
                        <CardContent style={{textAlign:"center"}} id="resultscontent">
                           {resultItems}
                        </CardContent>
                    </Card>
                </Grid>
            )
        } else{
            return (
                <Grid>
                    <Card className={classes.card} height="4" raised="true" id="results" style={{paddingLeft:'3vw', paddingRight:'3vw'}}>
                        <CardContent style={{textAlign:"center"}}>
                            <Speedometer score={this.props.results.AssessmentFrame.Score} type="GRADIENT"/>                        
                            <TextSection type="RISK" text={this.props.results.AssessmentFrame.RiskText} />
                            <TextSection type="SCIENCE" text={this.props.results.AssessmentFrame.ScienceText} />
                            <TextSection type="ACTION" text={this.props.results.AssessmentFrame.CallToActionText} />
                        </CardContent>
                        <ButtonGroup buttons={this.props.results.Buttons} />
                    </Card>
                </Grid> 
                
            )
        }
        
    } 
}

export default withStyles(useStyles)(QuizResults);